export default __webpack_public_path__ + "static/media/TF_20.6bfbbf12.png";